/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { helpCenterSettingsCustomerAccessAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-customer-access/src/HelpCenterSettingsCustomerAccessAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { HelpCenterSettingsCustomerAccess as HelpCenterSettingsCustomerAccessType } from '@jira/spa-apps__help-center-settings-customer-access/src/HelpCenterSettingsCustomerAccess.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const helpCenterSettingsCustomerAccessAppPageEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({
	main,
});

export const LazyHelpCenterSettingsCustomerAccess: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof HelpCenterSettingsCustomerAccessType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-help-center-settings-customer-access", jiraSpaEntry: "async-help-center-settings-customer-access" */ '@jira/spa-apps__help-center-settings-customer-access/src/HelpCenterSettingsCustomerAccessPage.tsx'
			),
		),
	);

export const HelpCenterSettingsCustomerAccess = (): React.JSX.Element => (
	<LazyPage
		Page={LazyHelpCenterSettingsCustomerAccess}
		pageId="help-center-settings-customer-access"
		shouldShowSpinner
	/>
);
